import { BaseReducer } from '@hobs/utils/baseReducer';
import { list, tree, GET, CLEAR } from '@hobs/constants/annex';

class Annex extends BaseReducer {
  static defaultState = {
    list: [],
    tree: [],
    annex: null
  };

  constructor() {
    super(Annex.defaultState);

    this.actionMap = {
      [list.SUCCESS]: this.addAnnexesList,
      [tree.SUCCESS]: this.addAnnexesTree,
      [GET.SUCCESS]: this.getAnnex,
      [CLEAR.SUCCESS]: this.clearAnnex
    };
  }

  addAnnexesList = (state, action) => {
    return Object.assign({}, state, { list: action.annexes });
  };

  addAnnexesTree = (state, action) => {
    return Object.assign({}, state, { tree: action.annexes });
  };

  getAnnex = (state, action) => {
    return Object.assign({}, state, {
      annex: action.response
    });
  };

  clearAnnex = state => {
    return Object.assign({}, state, { annex: null });
  };
}
export default new Annex().reducer;
